export default function getBase64FromImageUrl(url) {
  return new Promise((resolve) => {
    if(!url) {
      resolve()
    }
    const img = new Image()

    img.setAttribute('crossOrigin', 'anonymous')

    img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height

        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        const dataURL = canvas.toDataURL('image/png')
        resolve(dataURL)
    }
    img.src = url
  })
}
